import { cn } from "@/app/utils/cn"
import { OptionType } from "@/app/utils/optionSelectType"
import { BasicSelect } from "@/view/components/BasicSelect"
import { CSSObjectWithLabel } from "react-select"

interface SelectProps {
  name: string
  label: string
  options: OptionType[]
  labelIcon?: React.ReactNode
  placeholder: string
  error?: string
}
export const Select = ({ name, label, options, placeholder, labelIcon, error }: SelectProps) => {
  return (
    <div className="">
      <BasicSelect
        classNameLabel={cn("text-gray-700 font-semibold text-left flex flex-col items-right", "[&_p]:hidden")}
        classNameContainer="h-auto"
        name={name}
        label={
          <div className="flex items-center ml-2">
            {labelIcon}
            <span className="text-gray-700 font-semibold text-left flex flex-col items-right">{label}</span>
          </div>
        }
        options={options as OptionType[]}
        placeholder={placeholder}
        styles={{
          control: (base: CSSObjectWithLabel) => ({
            ...base,
            minHeight: '40px',
            borderRadius: '12px',
            border: '1px solid darkgray!important',
            boxShadow: 'black',
          }),
          placeholder: (base: CSSObjectWithLabel) => ({
            ...base,
            color: '',
          }),
        }}
        hiddeError={true}
      />
      {error && (
        <div className="min-h-5 mt-1 text-left text-xs sm:text-sm text-error">{error}</div>
      )}
    </div>
  )
}